/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import _ from 'lodash';

import Accordion from '@components/accordion';
import FilterChips from '@components/filters/filter-chips';
import RatingRange from '@components/rating-range';

import style from './proximity.module.scss';

const ProximityFilter = ({
  isActive = true,
  value = 0,
  max,
  onChange,
  titleText,
  unit,
  backClass
}) => {
  const [open, setOpen] = useState(false);
  const [proximityValue, setProximityValue] = useState(value);

  React.useEffect(() => setProximityValue(value), [value]);

  const chips = React.useMemo(() => {
    if (value) return { chipText: `Under ${value || 0} ${unit || 'km'}` };
    else return {};
  }, [value]);

  const deleteChip = () => {
    onChange(0);
    setOpen(true);
  };

  return (
    <div>
      <Accordion
        open={open}
        setOpen={setOpen}
        title="Proximity"
        isSelected={!open}
        selectedChildren={
          value > 0 && <SelectedProximityFilter chips={chips} deleteChip={deleteChip} />
        }
      >
        <p className={`${style.p} ${backClass}`}>{titleText}</p>
        <RatingRange
          value={proximityValue}
          onChange={(val) => {
            setProximityValue(val);
            setTimeout(() => {
              onChange(val);
            }, 1000);
          }}
          max={max}
        />
      </Accordion>
    </div>
  );
};

export default React.memo(ProximityFilter, _.isEqual);

export const SelectedProximityFilter = ({ chips, deleteChip, dynamic = false }) => {
  const Wrapper = dynamic ? React.Fragment : 'div';
  const wrapperProps = dynamic ? {} : { className: style.selectFilterDiv };

  return (
    <Wrapper {...wrapperProps}>
      <FilterChips chipText={chips.chipText} deleteChip={deleteChip} />
    </Wrapper>
  );
};
